import { GridsService, GridsProvider, HttpService } from '@lk/api'

export const makeGridsService = (http: HttpService, baseUrl: string) =>
  new GridsService(new GridsProvider(http, baseUrl))
